import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Box } from '@moonpig/launchpad-components'
import { NAV_BUTTON_SIZE, NAV_BUTTON_SIZE_MOBILE } from '../constants'

const StyledCondensedViewEllipsisListItem = styled(Box)`
  ${s({
    display: { xs: 'block', md: 'none' },
  })}
`

const StyledEllipsis = styled.span`
  ${s({
    width: { xs: NAV_BUTTON_SIZE_MOBILE, md: NAV_BUTTON_SIZE },
    height: { xs: NAV_BUTTON_SIZE_MOBILE, md: NAV_BUTTON_SIZE },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'colorInteractionDeactivated',
    fontSize: '16px',
    fontWeight: '700',
  })}
`

type EllipsisProps = {
  itemKey: string
  condensedViewOnly?: boolean
}

export const Ellipsis: FC<EllipsisProps> = ({ itemKey, condensedViewOnly }) => {
  const ellipsis = <StyledEllipsis aria-hidden="true">...</StyledEllipsis>

  if (condensedViewOnly) {
    return (
      <StyledCondensedViewEllipsisListItem
        as="li"
        key={itemKey}
        aria-hidden="true"
      >
        {ellipsis}
      </StyledCondensedViewEllipsisListItem>
    )
  }

  return (
    <Box as="li" key={itemKey} aria-hidden="true">
      {ellipsis}
    </Box>
  )
}
